"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _directionTypes = _interopRequireDefault(require("../consts/direction-types"));

var _default = _propTypes.default.oneOf(Object.values(_directionTypes.default));

exports.default = _default;